module.exports = __webpack_public_path__ + "img/btn_announcement.cdc5a270.svg";